module.exports = __webpack_public_path__ + "static/media/icon-cocktail-grey.4c8af3bf.svg";